import { render, staticRenderFns } from "./FoodsRank.vue?vue&type=template&id=d1050ec6&scoped=true&"
import script from "./FoodsRank.vue?vue&type=script&lang=js&"
export * from "./FoodsRank.vue?vue&type=script&lang=js&"
import style0 from "./FoodsRank.vue?vue&type=style&index=0&id=d1050ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1050ec6",
  null
  
)

export default component.exports